import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import GenericModal from './GenericModal';

interface AirmaskInfoModalProps {
  open: boolean;
  onClose: () => void;
}

const AirmaskInfoModal: React.FC<AirmaskInfoModalProps> = ({ open, onClose }) => {
  return (
    <GenericModal
      open={open}
      onClose={onClose}
      maxWidth={480}
      ariaLabelledBy="airmask-info-modal-title"
      ariaDescribedBy="airmask-info-modal-description"
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 3,
          pt: 4,
          pb: 2,
        }}
      >
        <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img
            src="/logo192.png"
            alt="AirMask Logo"
            style={{ width: 96, height: 96 }}
          />
        </Box>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography
            id="airmask-info-modal-title"
            variant="h5"
            sx={{ fontWeight: 700, textAlign: 'left' }}
          >
            Habit Categories
          </Typography>
          <Divider sx={{ borderColor: 'primary.main', borderBottomWidth: 2, width: '100%' }} />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            <strong style={{ color: '#32CA1D' }}>Manage</strong><span style={{ color: '#32CA1D' }}> —</span> a special category which indicates the things you do to direct and maintain the ins and outs of your life. If you are doing your Manage category Habits, you are keeping your head above water.
          </Typography>
          <Typography id="airmask-info-modal-description" variant="body1" sx={{ color: 'text.secondary' }}>
            <strong style={{ color: '#32CA1D' }}>Custom category types</strong><span style={{ color: '#32CA1D' }}> —</span> eg "Create", "Learn". These Habits enhance the quality of your life beyond the minimum standard. They may be "bigger" endeavors that may take longer than Manage category habits to maintain and track, so progress towards these may be measured in <Link to="/today/blocks" style={{ color: '#32CA1D' }} onClick={onClose}>Blocks</Link> or in a unit of choice.
          </Typography>
        </Box>
      </Box>
    </GenericModal>
  );
};

export default AirmaskInfoModal;
